import { useAppSettingsContext } from "@/contexts/AppSettingsContext";

/**
 * Hook to access shared app settings from context.
 * Settings are loaded once and shared across all consumers.
 * Use refetch() to reload settings after updates.
 */
export const useAppSettings = () => {
  return useAppSettingsContext();
};
